var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input_num"},[_c('button',{on:{"click":_vm.minus}},[_vm._v(" - ")]),_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.counter_num},on:{"change":_vm.inputChange}}),_c('button',{on:{"click":_vm.plus}},[_vm._v(" + ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }